/**
 * @generated SignedSource<<a0a253e2844f1dd9298b7a8e271c57c9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FilterButtonMe_employee$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"Avatar_employee">;
  readonly " $fragmentType": "FilterButtonMe_employee";
};
export type FilterButtonMe_employee$key = {
  readonly " $data"?: FilterButtonMe_employee$data;
  readonly " $fragmentSpreads": FragmentRefs<"FilterButtonMe_employee">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FilterButtonMe_employee",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Avatar_employee"
    }
  ],
  "type": "Employee",
  "abstractKey": null
};

(node as any).hash = "ef449e1ac2dbeaa6ead05bc1ad54f7d5";

export default node;
